import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';

export const appModuleNav = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent],
});
